import { FacetItem, CheckboxFacetType, FacetChangeEvent } from "../../SearchFilterResultData";

export function resetCheckboxFacet(facet: CheckboxFacetType): CheckboxFacetType {
  const newItems = facet.items.map((facetItem) => ({
    ...facetItem,
    checked: false,
  }));

  return { ...facet, items: newItems };
}

function toggleCheckbox(facet: CheckboxFacetType, selectedItem: FacetItem): CheckboxFacetType {
  const newItems = facet.items.map((item) =>
    item.id === selectedItem.id ? { ...item, checked: !item.selected } : item
  );

  return { ...facet, items: newItems };
}

type CheckboxesProps = {
  facet: CheckboxFacetType;
  onChange: FacetChangeEvent;
  disabled?: boolean;
};

export function Checkboxes({ facet, onChange, disabled }: CheckboxesProps) {
  const visibleItems = facet.items.filter(
    (item) => item.visible && item.count !== undefined && item.count > 0
  );

  function handleItemChange(item: FacetItem) {
    const newFacet = toggleCheckbox(facet, item);

    onChange(newFacet);
  }

  return (
    <ul className="facet-checkboxes checkbox-group">
      {visibleItems.map((item) => (
        <li key={item.id}>
          <input
            id={item.id}
            type="checkbox"
            name={item.name}
            checked={item.selected}
            onChange={() => handleItemChange(item)}
            disabled={disabled}
          />
          <label htmlFor={item.id}>{item.name}</label>
        </li>
      ))}
    </ul>
  );
}
